import Page     from '@app/templates/vuejs/pages/VideosPage'
import factory  from '@core/vuejs/services/client.factory.service'
import VideoStore from "@core/vuejs/js/store/video.store";
import {registerCommonsComponents} from '@app/assets/js/vue/components/partials/commons'

const componentsToRegister = [registerCommonsComponents]

const bundle = factory.createApp(Page, '#app', componentsToRegister, VideoStore)

export default bundle